import { Paper, Box, Grid, Typography, makeStyles } from '@material-ui/core';
import durationToString from '../../../utils/durationToString';
import { ACCEPTED_COLOR, REJECTED_COLOR } from './palette';

const useStyles = makeStyles(theme => ({
    tile: {
        padding: theme.spacing(2),
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('sm')]: {
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`
        }
    },
    value: {
        lineHeight: 1.1
    }
}));

// The headline numbers of the tournament, read before anything below them
function SummaryCard(props) {
    const classes = useStyles();
    const { played, wins, losses, solves, submissions, timePerSolve } = props.summary;
    const accepted = props.verdicts?.find(verdict => verdict.verdict === 'OK');
    const tiles = [
        { label: 'Matches played', value: played },
        {
            label: 'Record',
            value: (
                <>
                    <span style={{ color: ACCEPTED_COLOR }}>{wins}</span>
                    <span> — </span>
                    <span style={{ color: REJECTED_COLOR }}>{losses}</span>
                </>
            ),
            note: 'won — lost'
        },
        { label: 'Tasks solved', value: solves },
        {
            label: 'Time per solve',
            value: durationToString(timePerSolve),
        },
        { label: 'Submissions', value: submissions },
        {
            label: 'Accepted',
            value: submissions === 0 ? '—' : `${accepted?.percentage.toFixed(1) ?? '0.0'}%`,
            note: submissions === 0 ? null : `${accepted?.count ?? 0} / ${submissions}`
        }
    ];
    return (
        <Paper elevation={6}>
            <Grid container>
                {tiles.map((tile, index) => (
                    <Grid
                        item xs={6} md
                        key={tile.label}
                        className={index === tiles.length - 1 ? undefined : classes.tile}
                        style={index === tiles.length - 1 ? { padding: 16 } : undefined}
                    >
                        <Typography variant='body2' color='textSecondary' noWrap> {tile.label} </Typography>
                        <Typography variant='h4' className={classes.value}> {tile.value} </Typography>
                        <Box height={20}>
                            {tile.note && <Typography variant='caption' color='textSecondary' noWrap> {tile.note} </Typography>}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}

export default SummaryCard;
